import {
  getExcludedViolations,
  getTenantCustomViolations,
  getTenantRules,
} from "api";
import { Rule, Violation } from "types";

export interface ViolationsQueryParams {
  params: {
    tenantID?: number;
  };
}

export interface ViolationsLoaderData {
  _tenantViolations: Promise<Violation[]>;
  _excludedViolations: Promise<Violation[]>;
  _tenantRules: Promise<Rule[]>;
}

export default function violationsLoader({
  params,
}: ViolationsQueryParams): ViolationsLoaderData {
  return {
    _tenantViolations: getTenantCustomViolations(params.tenantID || 0),
    _excludedViolations: getExcludedViolations(params.tenantID || 0),
    _tenantRules: getTenantRules(params.tenantID || 0),
  };
}
